import React from 'react';

export default ({ title, children }) => (
  <div className="wrapper">
    <div>{children}</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/wrapper.js